import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4 4v16h16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m4 20 7-7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Axis3d";
const Axis3d = memo(themed(Icon));
export {
  Axis3d
};
//# sourceMappingURL=axis-3d.js.map
